import { render, staticRenderFns } from "./ModalBooksAdd.vue?vue&type=template&id=e6512d0c&scoped=true&"
import script from "./ModalBooksAdd.vue?vue&type=script&lang=js&"
export * from "./ModalBooksAdd.vue?vue&type=script&lang=js&"
import style0 from "./ModalBooksAdd.vue?vue&type=style&index=0&id=e6512d0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6512d0c",
  null
  
)

export default component.exports